/**
 * Fire-and-forget visitor-IP beacon for the public widget embed.
 *
 * On session start the widget POSTs the booking nonce directly to the
 * control-plane so it can read the visitor's REAL browser IP (the session
 * itself is minted by the tenant's backend, whose server IP would otherwise
 * be all the control-plane sees). Authorized by the publishable key and the
 * control-plane's domain enforcement, exactly like `/config` and
 * `/public/booking`.
 *
 * Guards: sends ONLY when both a publishable key and a non-empty booking
 * nonce are present. The control-plane returns `booking_nonce = null` when
 * the session insert failed, so a missing/empty nonce means "skip".
 *
 * Fail-open: never throws. Any network or non-2xx error is swallowed so the
 * beacon can never block or break the voice session.
 */
function stripTrailingSlashes(s) {
    let i = s.length;
    while (i > 0 && s.charCodeAt(i - 1) === 47 /* "/" */)
        i--;
    return s.slice(0, i);
}
export async function sendVisitorBeacon({ serviceUrl, publishableKey, bookingNonce, }) {
    // No serviceUrl would resolve to a relative path against the host page's
    // origin; skip instead of posting to the integrator's own server.
    if (!serviceUrl || !publishableKey || !bookingNonce)
        return;
    // A slashes-only serviceUrl (e.g. "///") strips down to an empty base,
    // which would also produce a relative URL; skip that too.
    const base = stripTrailingSlashes(serviceUrl);
    if (!base)
        return;
    const url = `${base}/api/founding-agent/public/visitor-beacon?key=${encodeURIComponent(publishableKey)}`;
    try {
        await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ nonce: bookingNonce }),
        });
    }
    catch {
        // Fail-open: enrichment must never block or break the call.
    }
}
